import { Component, HostBinding, OnInit } from '@angular/core';
import { IPolicies } from '../../shared/models/policies.interface';
import { LoginService } from '../../services/login.service';
import { Title } from '@angular/platform-browser';
import { AccountInfo } from '../../shared/models/account-info.interface';
import { UserService } from 'src/app/services/user.service';
import { PolicyService } from 'src/app/services/policy.service';
import en from 'src/assets/i18n/en.json';
import { TaggingService } from 'src/app/tags/tagging.service';
import { UserPermission } from 'src/app/shared/models/user-permission';
import { ActivatedRoute, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { GuestLinkService } from 'src/app/services/guest-link.service';

@Component({
  selector: 'upsc-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  @HostBinding('class') public hostClass = 'dashboard';

  //User info
  isCanadaUser: boolean;
  isUkUser: boolean;
  isGermanyUser: boolean;
  isFranceUser: boolean;
  isItalyUser: boolean;
  isUsaUser: boolean;
  userDetails: AccountInfo;
  userPermission: UserPermission = new UserPermission();

  //Policy
  PolicyNo: string;
  policyType: string;
  policies: IPolicies;
  isInsureShield: boolean = false;
  isThreeContractNo: boolean;
  isContract: boolean = false;
  basicPolicy;

  //Display vars
  insured: string;
  showDucumentNotification: boolean = false;
  showBilling: boolean = false;
  showInsights: boolean;

  //roles
  isAdminRole: boolean = false;

  constructor(
    private loginService: LoginService,
    private titleService: Title,
    private userService: UserService,
    private policyService: PolicyService,
    private taggingService: TaggingService,
    private route: ActivatedRoute,
    private router: Router,
    private guestLinkService: GuestLinkService
  ) {
    this.userDetails = this.userService.getUserInfo();
    // let changeplan = JSON.parse(sessionStorage.getItem('changeplanSuccess'));
    // if (changeplan?.statusCode == "200") {
    //   this.router.navigate(['/dd-visibility']);
    // }
  }

  ngOnInit() {
    this.isAdminRole = this.userService.isAdminRole();
    this.route.data.pipe(
      map((rawRes) => {
        return rawRes.DashboardData ?? rawRes;
      })
    ).subscribe(
      res => {  //This stuff comes from resolver, which I believe only comes when it is a user login, not an internal user.
        if (res.dwDetails && res.dwDetails.data?.wallet) {
          sessionStorage.setItem('dwDetails', JSON.stringify(res.dwDetails.data.wallet));
        }
        if (res.ccpUniquePartnerName) {
          if (res.ccpUniquePartnerName.message == 'Found') {
            if (res.ccpUniquePartnerName.data?.portalType?.toLowerCase() == 'ssp') {
              sessionStorage.setItem('ccpUniquePartnerName', JSON.stringify({
                ccp_selfService_Check: true,
                unique_Partner_Name: res.ccpUniquePartnerName.data.partnerName
              }));
              this.guestLinkService.ccpSSPChecked(res.ccpUniquePartnerName.data.partnerName);
            }
          }
          else {
            let policyDetails = JSON.parse(sessionStorage.getItem('policyDetails'));
            if (policyDetails?.sspIndicator === true) {
              let partnerName = policyDetails?.insured?.replace(/[^a-zA-Z0-9\-_]/g, '');
              sessionStorage.setItem('ccpUniquePartnerName', JSON.stringify({
                ccp_selfService_Check: true,
                unique_Partner_Name: partnerName
              }));
              this.guestLinkService.ccpSSPChecked(partnerName);
              if (this.isAdminRole) {
                this.guestLinkService.updateCcpInfo({
                  "partnerName": partnerName,
                  "policyNumber": policyDetails?.policyNumber,
                  "portalType": 'SSP',
                  "companyLogo": '',
                  "companyStyle": '',
                  "lastModifiedBy": this.userDetails?.userId
                }).subscribe(); //try inserting into database
              }
            }
          }
        }
        if (res.childPolicies && res.childPolicies.data?.childPolicies) {
          sessionStorage.setItem('childPolicies', JSON.stringify(res.childPolicies.data.childPolicies));
        }
        if (res.is4upsQuoteDetails && res.is4upsQuoteDetails.data?.newRate) {
          sessionStorage.setItem('is4upsQuoteDetails', JSON.stringify(res.is4upsQuoteDetails.data));
        }
      }
    );

    this.determineUserLocale();
    this.gatherPolicyInfo();
    this.determineBillingType();
    this.taggingService.view();
    this.titleService.setTitle(en.dashboard.setTitle);
    this.insured = localStorage.getItem("insured");
    this.showInsights = this.policyService.hasInsights();
    this.userPermission = this.userService.getUserPermissions();
  }

  toggleDocumentNotification(toggle: any) {
    this.showDucumentNotification = toggle;
  }

  tagging(type) {
    if (type == 'viewPolicies') {
      this.taggingService.link({ link_name: 'view_your_policies_dashboard' });
    } else if (type == 'viewClaims') {
      this.taggingService.link({ link_name: 'file_a_claim_dashboard' });
    } else if (type == 'billing') {
      this.taggingService.link({ link_name: 'view_and_pay_invoices_dashboard' });
    } else if (type == 'viewAllClaims') {
      this.taggingService.link({ link_name: 'view_all_claims_dashboard' });
    } else if (type == 'viewAllInvoices') {
      this.taggingService.link({ link_name: 'view_all_invoices_dashboard' });
    }
  }

  determineUserLocale() {
    this.isCanadaUser = this.userService.isCanadaUser();
    this.isUkUser = this.userService.isUkUser();
    this.isGermanyUser = this.userService.isGermanyUser();
    this.isFranceUser = this.userService.isFranceUser();
    this.isItalyUser = this.userService.isItalyUser();
    this.isUsaUser = this.userService.isUsaUser();
  }

  gatherPolicyInfo() {
    this.policies = this.loginService.getPolicyDetails();
    this.PolicyNo = this.policies.policyNumber;
    this.policyType = this.policyService.determinePolicyType(this.policies);
    this.isThreeContractNo = this.policyService.isThreeHyphenContractNo();
    if (this.policyType == 'transactional_parcel' || this.policyType == 'transactional_cargo' || this.policyType == 'traditional_cargo') {
      this.policyType = "InsureShield";
      this.isInsureShield = true;
    } else {
      this.policyType = `${this.policies.productName} ${this.policies.subPolicyType}`;
      this.isInsureShield = false;
    }
    this.basicPolicy = this.loginService.getPolicyDetails();
    if (this.policies?.policyTypeIndicator === "Contract") {
      this.isContract = true;
    }
  }

  determineBillingType() {
    // let dwDetails = JSON.parse(sessionStorage.getItem('dwDetails'));
    // if (dwDetails && dwDetails?.billingType && dwDetails?.billingType?.trim()?.toLowerCase() == 'ups') {
    //   this.showBilling = false;
    // } else {
    //   this.showBilling = this.policyService.isGWPolicy();
    // }
    this.showBilling = this.policyService.isGWPolicy();

  }
}
